import React from "react";
import { createRoot } from "react-dom/client";
import axios from "axios";
import "@/index.css";
import App from "@/App";

const configuredBackendOrigin = (process.env.REACT_APP_BACKEND_URL || "").replace(/\/+$/, "");

if (
  typeof window !== "undefined"
  && configuredBackendOrigin
  && !["localhost", "127.0.0.1"].includes(window.location.hostname)
) {
  const runtimeOrigin = window.location.origin.replace(/\/+$/, "");
  const rewriteApiUrl = (url) => {
    if (typeof url !== "string") return url;
    return url.startsWith(`${configuredBackendOrigin}/api`)
      ? url.replace(configuredBackendOrigin, runtimeOrigin)
      : url;
  };

  const originalOpen = window.XMLHttpRequest?.prototype?.open;
  if (originalOpen) {
    window.XMLHttpRequest.prototype.open = function patchedOpen(method, url, ...rest) {
      return originalOpen.call(this, method, rewriteApiUrl(url), ...rest);
    };
  }

  const originalFetch = window.fetch?.bind(window);
  if (originalFetch) {
    window.fetch = (input, init) => {
      if (typeof input === "string") {
        return originalFetch(rewriteApiUrl(input), init);
      }
      if (input instanceof Request) {
        const rewrittenUrl = rewriteApiUrl(input.url);
        if (rewrittenUrl !== input.url) {
          const rewrittenRequest = new Request(rewrittenUrl, input);
          return originalFetch(rewrittenRequest, init);
        }
      }
      return originalFetch(input, init);
    };
  }

  axios.interceptors.request.use((config) => {
    if (typeof config.url === "string") {
      return { ...config, url: rewriteApiUrl(config.url) };
    }
    return config;
  });
}

const rootElement = document.getElementById("root");

const app = (
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

const root = createRoot(rootElement);
root.render(app);
